import { ReactionInfoButton } from './ReactionInfoButton';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import Message from 'owa-service/lib/contract/Message';
import { ClientItemId } from 'owa-client-ids';
import { InstrumentationContext } from 'owa-search/lib/types/InstrumentationContext';

export interface ReactionsOnMessageContainerProps {
    conversationId: ClientItemId;
    itemId: ClientItemId;
    message: Message;
    instrumentationContext: InstrumentationContext;
    isInCollapsedRP?: boolean;
}

export const ReactionsOnMessageContainer = observer(function ReactionsOnMessageContainer(
    props: ReactionsOnMessageContainerProps
) {
    const getAllReactionsFromMessage = (): JSX.Element[] => {
        const reactions: JSX.Element[] = [];
        if (props.message.Reactions) {
            const ownerCurrentReactionType = props.message.OwnerReactionType;
            props.message.Reactions.forEach(reaction => {
                reactions.push(
                    <ReactionInfoButton
                        key={reaction.ReactionType}
                        reactionInfo={reaction}
                        ownerReactionType={ownerCurrentReactionType}
                        conversationId={props.conversationId}
                        itemId={props.itemId}
                        message={props.message}
                        instrumentationContext={props.instrumentationContext}
                        isInCollapsedRP={props.isInCollapsedRP}
                    />
                );
            });
        }
        return reactions;
    };

    return <>{getAllReactionsFromMessage()}</>;
});
